/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Public_FilesInputs */

const en_no_public_files = /** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No public files available.`)
};

const id_no_public_files = /** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada file publik yang tersedia.`)
};

/** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */
const es_no_public_files = en_no_public_files;

/** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */
const fr_no_public_files = en_no_public_files;

/** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */
const de_no_public_files = en_no_public_files;

/** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */
const ja_no_public_files = en_no_public_files;

/** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */
const zh_no_public_files = en_no_public_files;

/** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */
const ar_no_public_files = en_no_public_files;

/** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */
const it_no_public_files = en_no_public_files;

/** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */
const ru_no_public_files = en_no_public_files;

/** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */
const pt_no_public_files = en_no_public_files;

/** @type {(inputs: No_Public_FilesInputs) => LocalizedString} */
const ko_no_public_files = en_no_public_files;

/**
* | output |
* | --- |
* | "No public files available." |
*
* @param {No_Public_FilesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_public_files = /** @type {((inputs?: No_Public_FilesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Public_FilesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_public_files(inputs)
	if (locale === "es") return es_no_public_files(inputs)
	if (locale === "fr") return fr_no_public_files(inputs)
	if (locale === "de") return de_no_public_files(inputs)
	if (locale === "ja") return ja_no_public_files(inputs)
	if (locale === "zh") return zh_no_public_files(inputs)
	if (locale === "ar") return ar_no_public_files(inputs)
	if (locale === "id") return id_no_public_files(inputs)
	if (locale === "it") return it_no_public_files(inputs)
	if (locale === "ru") return ru_no_public_files(inputs)
	if (locale === "pt") return pt_no_public_files(inputs)
	return ko_no_public_files(inputs)
});